// extracted by mini-css-extract-plugin
module.exports = {"ABDS":"DeltaBaseH5_ABDS__bT3m8"};